<div class="container-fluid">
  <div class="page-title">
    <div class="row">
      <div class="col-6 d-flex align-items-center">
        <button  *ngIf="title === 'Report-List'"   class="btn btn-light back-report-list-btn me-2" routerLink="/Products/report-listing"><i class="icon-arrow-left f-14"></i></button>
        <h3>{{ title }}</h3>
      </div>
      <div class="col-6">
        <ol class="breadcrumb">
          <!-- <li class="breadcrumb-item">
            <a>
              <svg class="stroke-icon">
                <use href="assets/svg/icon-sprite.svg#stroke-home"></use>
              </svg>
            </a>
          </li> -->
          <li class="breadcrumb-item" *ngFor="let item of items">{{ item }}</li>
          <li class="breadcrumb-item active">{{ active_item }}</li>
        </ol>
      </div>
    </div>
  </div>
</div>
